<template>
    <router-view v-slot="{ Component }">
        <component :is="Component" :competition="readOneCompetition" />
    </router-view>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'

// GraphQL query
const readCompetitionQuery = gql`
    query($urlSegment: String!) {
      readOneCompetition( filter: { urlSegment: { eq: $urlSegment }}){
        title
        menuTitle
        link
        content
        summary
        date_CallForSubmissions
        date_ApplicationsDue
        date_SubmissionsDue
        date_FinalistsAnnounced
        date_WinnersAnnounced
        highlightsLabel
        heroImage {
          large
        }
        subnav {
            edges {
                node {
                    menuTitle
                    link
                }
            }
        }
        featuredEntries {
            edges {
                node {
                    title
                    thumbnail
                    link
                    name
                    year {
                        title
                    }
                    medium {
                        title
                    }
                    prize {
                        id
                        title
                        prize
                    }
                }
            }
        }
        years {
            edges {
                node {
                    title
                    entriesCount
                    winnersCount
                    hidden
                    hideEntriesFilter
                    hideWinnersFilter
                }
            }
        }
      }
    }
`

export default {
    inject: ['state'],
    data() {
        return {
            readOneCompetition: {},
            urlSegment: this.$route.params.id
        }
    },
    watch: {
    '$route' (to, from) {
          this.urlSegment = to.params.id
        }
    },
    apollo: {
        readOneCompetition: {
            // GraphQL query
            query: readCompetitionQuery,
            variables() {
                return {
                    urlSegment: this.urlSegment
                }
            },
            loadingKey: 'loading',
            result(result) {
                if(result.data.readOneCompetition?.subnav?.edges.length) {
                    let items = []
                    _.each(result.data.readOneCompetition.subnav.edges, (item) => {
                        items.push({
                            title: item.node.menuTitle,
                            link: item.node.link
                        })
                    })
                    this.state.api.subnav = items
                }
                else {
                    this.state.api.subnav=[]
                }
            }
        }
    }
    // ,
    // computed: {
    //     competition() {
    //         return this.readOneCompetition
    //     }
    // }
}
</script>
